import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'tl;dv Case Study | Canny';
const Description =
  'Read about how tl;dv uses Canny to transform customer feedback into product innovation.';
const Image = 'https://canny-assets.io/images/77f6b95cbe0e7fd9ac5d2f34d2a732e7.png';

export default class TLDVLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/tldv' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
